import { moduleProviderFactory } from 'core/providers';
import { OrderingDoctorList } from 'application/ordering-doctor/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.ordering-doctor',
                pattern: '/ordering-doctor',
                children: [
                    {
                        name: 'master.app.main.ordering-doctor.list',
                        pattern: '',
                        tabTitle: 'ORDERING_DOCTOR.LIST.TITLE_SECONDARY',
                        component: OrderingDoctorList,
                        data: {
                            title: 'ORDERING_DOCTOR.LIST.TITLE_SECONDARY'
                        }
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.ORDERING_DOCTOR_SUB',
                        route: 'master.app.main.ordering-doctor.list',
                        order: 8,
                    }                    
                ]
            }
        ]
    });
})();
